<template>
<div>
  <b-form @submit="onSubmit" class="text-center">
    <b-row class="pt-4">
      <b-col>
        <h3>{{$t('label.passwordChange')}}</h3>
      </b-col>
    </b-row>
    <!-- paswd -->
    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-input-group>
          <b-form-input :type="paswdVisibility ? 'text' : 'password'" v-model.trim="$v.form.paswd.$model" :placeholder="$t('label.paswd')"></b-form-input>
          <template #append>
            <b-input-group-text><span @click="paswdVisibility = !paswdVisibility"><font-awesome-icon :icon="iconPaswd" /></span></b-input-group-text>
          </template>
        </b-input-group>
        
        <div class="text-danger" v-if="!$v.form.paswd.required && $v.form.paswd.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.paswd.maxLength && $v.form.paswd.$dirty">{{ $t("info.maxLength", [20]) }}</div>
        <div class="text-danger" v-if="!$v.form.paswd.minLength && $v.form.paswd.$dirty">{{ $t("info.minLength", [8]) }}</div>
        <div class="text-danger" v-if="paswdInvalid">{{ $t("info.paswdValidation") }}</div>
        <b-form-text id="password-int">{{$t('info.paswdInt')}}</b-form-text>
        </b-col>
    </b-row>
    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-input-group>
          <b-form-input :type="confPaswdVisibility ? 'text' : 'password'" v-model.trim="$v.form.confPaswd.$model" :placeholder="$t('label.confPaswd')"></b-form-input>
          <template #append>
            <b-input-group-text><span @click="confPaswdVisibility = !confPaswdVisibility"><font-awesome-icon :icon="iconConfPaswd" /></span></b-input-group-text>
          </template>
        </b-input-group>      
        <div class="text-danger" v-if="!$v.form.confPaswd.sameAsPassword && $v.form.confPaswd.$dirty">{{ $t("info.sameAs") }}</div>
        </b-col>
    </b-row>
    
    <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("label.submit") }}</b-button>

    </b-form>

    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

     <!-- User not exist -->
    <div v-if="noExistingUser" class="text-center pt-4">
        <b-alert sm="6" show variant="warning">
            <p>{{ $t("info.noExistingUser") }}</p>
        </b-alert>
    </div>

    <!-- error -->
    <div v-if="error" class="text-center pt-4">
        <b-alert show variant="danger">
            <p>{{ error }}</p>
        </b-alert>
    </div>
    
</div>
</template>

<script>

import axios from 'axios';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { required, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
props: [],
data() {
    return {
      form: {
        paswd: "",
        confPaswd: "",
      },     
      error: "",
      disabled: false,
      spinner: false,
      paswdInvalid: false,
      paswdVisibility: false,
      confPaswdVisibility: false,
      noExistingUser: false
    }
  },
validations() {
    return {
      form: {
        paswd: {
          required,
          maxLength: maxLength(20),
          minLength: minLength(8)
        },
        confPaswd: {
          sameAsPassword: sameAs('paswd')
        }
    }
  }
},
computed: {
  iconPaswd: function () {
    return this.paswdVisibility ? faEye : faEyeSlash;
  },
  iconConfPaswd: function () {
    return this.confPaswdVisibility ? faEye : faEyeSlash;
  },
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  user: function () {
    return this.$store.getters.getUser;
}
},
methods:{
    validatePaswd : function () {
        let paswd = this.form.paswd;
        let pass = false;
        let letter = false;
        let digit = false;
        let uppercase = false;
        let acceptedChar = false;
        let lettersNumbersReg = /^[0-9a-zA-Z]+$/;
        let lettersReg = /^[a-zA-Z]+$/;

        for (let i=0; i < paswd.length; i++) {
            let char = paswd.charAt(i);

            //acceptedChar
            if (lettersNumbersReg.test(char)) {
                acceptedChar = true;
                //letter
                if (lettersReg.test(char)) {
                    letter = true;
                    //uppercase
                    if (char == char.toUpperCase()) {
                        uppercase = true;
                    }
                }
                
                //digit
                if (!isNaN(char)){
                    digit = true;
                }

            }

            else {
                acceptedChar = false;
                break;
            }
        }

        if (acceptedChar && letter && uppercase && digit) {
            pass = true;
        }

        else {
            this.paswdInvalid = true;
        }

        return pass;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      this.paswdInvalid = false;
      this.noExistingUser = false;
      this.$v.$touch();
      if (!this.$v.$invalid && this.validatePaswd()) { 
          let obj = {
              paswd: this.form.paswd,
              email: this.user.Email
          }
          
          this.disabled = true;
          this.spinner = true;
          
          axios.post(this.url, {request: "updatePaswd", form: obj }, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.disabled = false;
                this.spinner = false;

                if (response.data === 0) {
                  this.setNextPage('Login');
                }
                else if(response.data === 1) {
                  this.noExistingUser = true;
                }
                else {
                  this.error = this.$t('info.errorgeneric');
                }
                
            })
            .catch(()  => {
                this.error = this.$t('info.errorgeneric');
                this.spinner = false;
                this.disabled = false;
            }); 
      }
    },
    setNextPage(page) {      
      this.$emit('changePage', page);        
    }
},
components: {}
}
</script>